import React, { useContext, useEffect, useState } from 'react';
import { DataContext } from '../../context/dataContext';
import apiHandler from '../../common/config/apiHandler';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import EmailEvents from '../../common/config/email-events';
import { Table } from 'reactstrap';
import CustomLoader from "../../components/Loader/loader"


const EmailEventsSection = () => {
  const navigate = useNavigate();
  const { bookingDetails, subscribeKey, setSubscribeKey, fetchSubscribeKey } = useContext(DataContext);
  const [emailEvents, setEmailEvents] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (bookingDetails?.bookingDetails?.length > 0) {
      fetchSubscribeKey();
    } else {
      toast.error('Failed to fetch booking details.');
    }
  }, [bookingDetails, fetchSubscribeKey]);

  const handleFetchEmailEvents = async () => {
    if (subscribeKey) {
      setLoader(true);
      try {
        const emailEventsResponse = await EmailEvents({
          key: subscribeKey,
          reference_no: bookingDetails?.reference_no,
        });

        if (emailEventsResponse.response_code === 200) {
          setEmailEvents(emailEventsResponse?.data?.smtp_webhook || []);
        } else {
          toast.error('Failed to fetch email events.');
        }
      } catch (error) {
        toast.error('An error occurred while fetching email events.');
      } finally {
        setLoader(false);
      }
    }
  };

  useEffect(() => {
    if (subscribeKey) {
      handleFetchEmailEvents();
    }
  }, [subscribeKey]);

  return (
    <div>
      {loader ? (
        <CustomLoader/>
      ) : (
      
        emailEvents?.length == 0 ? <h6 className='text-center' style={{fontWeight:'bold'}}>No Email Events</h6> :   <div
        style={{
          height: '400px', 
          overflowY: 'auto',
          border: '1px solid #ddd',
          borderRadius: '4px',
        }}
      >
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th style={{ width: '25%' }}>Event</th>
              <th style={{ width: '25%' }}>Recipient</th>
              <th style={{ width: '25%' }}>Date</th>
            </tr>
          </thead>
          <tbody>
          {emailEvents?.map((event, index) => (
              <tr key={index}>
                <td style={{textTransform:'capitalize'}}>{event?.event}</td>
                <td>{event?.rcpt}</td>
                <td>
  {new Date(event?.time).toLocaleString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).replace(/\//g, '-')}
</td>

              </tr>
            ))}
          </tbody>
        </Table>
      </div> 
      
      )}
    </div>
  );
};

export default EmailEventsSection;
